import { React } from "react";
const Reporte1 = ({ nombre, mdstatus, eseditable }) => {
    return(
        <div className=" w-full h-full">
        <iframe className=" w-full h-full border-0"
        src="https://lookerstudio.google.com/embed/reporting/31b6f4c6-190b-446c-b362-a581b4db1525/page/GHRBE" 
        allowfullscreen sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"></iframe></div>
    )
}
export default Reporte1;